/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.PortalInstanceListingRpc
 */
import * as References from './PortalInstanceListingRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import portalsHttpClient from 'portals-platform-lib/portalsHttpClient';
import { registerQuery } from 'data-fetching-client/next';
export const chirpClient = createRpcClientV2({
  hubHttpClient: portalsHttpClient
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.PortalInstanceListingRpc#getPortalInstanceListing
 */
export const GET_PORTAL_INSTANCE_LISTING_QUERY_FIELD_NAME = 'com_hubspot_portals_platform_app_rpc_PortalInstanceListingRpc_getPortalInstanceListing';
export const GET_PORTAL_INSTANCE_LISTING_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PORTAL_INSTANCE_LISTING_QUERY_FIELD_NAME,
  args: ['membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getPortalInstanceListingRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.PortalInstanceListingRpc#listPortalInstancesOnSameDomain
 */
export const LIST_PORTAL_INSTANCES_ON_SAME_DOMAIN_QUERY_FIELD_NAME = 'com_hubspot_portals_platform_app_rpc_PortalInstanceListingRpc_listPortalInstancesOnSameDomain';
export const LIST_PORTAL_INSTANCES_ON_SAME_DOMAIN_QUERY = /* #__PURE__ */registerQuery({
  fieldName: LIST_PORTAL_INSTANCES_ON_SAME_DOMAIN_QUERY_FIELD_NAME,
  args: ['membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.listPortalInstancesOnSameDomainRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});